import { CreditCard, Image, Settings } from "react-feather"
import { ACL_READ, ACL_SUBJECT_CONFIGURATION } from "@configs/acl/constants"

export default [
    {
        id: "configuration",
        title: "Configuration",
        icon: <Settings />,
        children: [
            {
                id: "System",
                title: "System",
                icon: <Settings />,
                navLink: "/configurations",
                action: ACL_READ,
                resource: ACL_SUBJECT_CONFIGURATION
            },
            {
                id: "autoVerify",
                title: "autoVerify",
                icon: <CreditCard />,
                navLink: "/configurations/auto-verify",
                action: ACL_READ,
                resource: ACL_SUBJECT_CONFIGURATION
            },
            {
                id: "banner",
                title: "Banner",
                icon: <Image />,
                navLink: "/configurations/banner",
                action: ACL_READ,
                resource: ACL_SUBJECT_CONFIGURATION
            }
        ]

    }
]
